module.exports = __webpack_public_path__ + "img/HU10011922.c93bcd55.png";